module.exports = __webpack_public_path__ + "img/2f88ffcaa082cea57fa93abb28a2e3ce.cb70cb0d.png";